import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/pro-solid-svg-icons';
import { Button } from '@platzi/ui';
import { Track } from '@platzi/commons';
import { AddRouteButton } from '../';
import { ShareButton } from '../../shared/Share';
import ModalUnfollow from './ModalUnfollow';
import styles from './Actions.module.sass';

export const Actions = (props) => {
  const nextClass = useSelector((state) => state.get('route').get('material_data').get('material_url')) || '';
  const { t } = useTranslation();
  const router = useRouter();
  const { slug } = router.query;

  const [userFollowSchool, setUserFollowSchool] = useState(undefined);
  const [showModal, setShowModal] = useState(false);

  const recordFollowRoute = {
    event: 'route_follow_route',
    route_name: slug,
  };

  const recordClickData = {
    event: 'route_share_button',
    route_name: slug,
  };

  const recordSocialMediaClickData = {
    event: 'route_share_network',
    route_name: slug,
  };

  const onStartRouteClick = () => {
    Track.send({
      event: 'route_start_route',
      route_name: slug,
    });
    window.location.replace(nextClass);
  };

  return (
    <div className={styles.Actions}>
      <Button customClass={styles.StartCta} onClick={onStartRouteClick}>
        <FontAwesomeIcon icon={faPlay} />
        {t('route.actions.startRoute')}
      </Button>

      <AddRouteButton
        recordFollowRoute={recordFollowRoute}
        setShowModal={setShowModal}
        userFollowSchool={userFollowSchool}
        setUserFollowSchool={setUserFollowSchool}
      />
      <ShareButton
        isLogged={true}
        customClass={styles.ShareCta}
        recordClickEvent={recordClickData}
        recordSocialMediaClick={recordSocialMediaClickData}
        messages={{
          isLogged: t('route.actions.share'),
          notLogged: t('route.actions.share'),
          sharedCopy: t('route.actions.sharedCopy'),
        }}
        socialNetworkTitle={props.socialNetworkTitle}
      />
      <ModalUnfollow showModal={showModal} setShowModal={setShowModal} setUserFollowSchool={setUserFollowSchool} />
    </div>
  );
};
